// Presentation data remains within the existing CMS Section.items string array.
export const homeLink = value => typeof value === 'string' && !/[\s\\]/.test(value) && (/^https:\/\//i.test(value) || /^\/(?!\/)/.test(value)) ? value : '';
export function trustedCompanies(items = []) {
  return items.flatMap(item => {
    try {
      const row = JSON.parse(item);
      if (!row || typeof row.name !== 'string' || !row.name.trim()) return [];
      return [{name: row.name.slice(0,100), logo: homeLink(row.logo), website: homeLink(row.website),
        role: ['Exhibitor','Industry Partner','Founding Exhibitor'].includes(row.role) ? row.role : '', founding: row.founding === true}];
    } catch {return typeof item === 'string' && item.trim() && !item.trim().startsWith('{') ? [{name:item.slice(0,100),logo:'',website:'',role:'',founding:false}] : [];}
  });
}
